import Select from '../Select';
import TextInput from '../TextInput';
import DurationInput from '../DurationInput.jsx';
import MoneyInput from '../MoneyInput.jsx';
import CompactEventTypeSelect from '../forms/CompactEventTypeSelect';
import { useEventTypesQuery } from '../../lib/Queries';
import InfoMessageBlock from '~/components/InfoMessageBlock';

const redeemableForTypeOptions = {
    minutes: 'Total amount of time',
    events: 'Total number of bookings',
    price: 'Total price',
    unlimited: 'Unlimited',
    nothing: 'Nothing',
    specific: 'Specific amount for each type...',
};

const SpecificEventTypeInput = ({ value, onChange }) => {
    const { data } = useEventTypesQuery();
    const eventTypes = data || [];

    const redeemable = [];
    for (const type of eventTypes) {
        if (value[type.id] > 0) {
            redeemable.push(
                `${value[type.id]} ${type.name} event${value[type.id] > 1 ? 's' : ''}`,
            );
        }
    }

    let humanText = '';
    if (redeemable.length > 0) {
        humanText = 'This is redeemable for ' + redeemable.join(' AND ');
    }

    return (
        <div className="flex flex-col space-y-4">
            {eventTypes.map(type => (
                <div className="flex items-center space-x-4" key={type.id}>
                    <div className="max-w-16">
                        <input
                            type="number"
                            className="max-w-16"
                            min={0}
                            value={
                                typeof value[type.id] === 'undefined'
                                    ? 0
                                    : value[type.id]
                            }
                            onChange={e =>
                                onChange({
                                    ...value,
                                    [type.id]: e.target.value,
                                })
                            }
                        />
                    </div>
                    <div>{type.name}</div>
                </div>
            ))}
            <div className="text-gray-500 text-sm">{humanText}</div>
        </div>
    );
};

const RedeemableForInput = ({ value, onChange, isNew }) => {
    return (
        <div>
            <div className="flex flex-col space-y-4">
                <Select
                    value={value?.type || ''}
                    id="redeemable_for.type"
                    onChange={newValue => {
                        onChange({ ...value, type: newValue, amount: '0' });
                    }}
                    options={redeemableForTypeOptions}
                    label="Redeemable For"
                />
                {value?.type === 'minutes' && (
                    <DurationInput
                        className="max-w-52"
                        id="redeemable_for.amount"
                        label="Total amount of Time"
                        value={value?.amount}
                        onChange={newValue =>
                            onChange({ ...value, amount: newValue || 0 })
                        }
                    />
                )}
                {value?.type === 'price' && (
                    <MoneyInput
                        id="redeemable_for.amount"
                        className="max-w-52"
                        label="Total Value"
                        value={value?.amount}
                        onChange={newValue =>
                            onChange({ ...value, amount: newValue || 0 })
                        }
                    />
                )}
                {value?.type === 'events' && (
                    <TextInput
                        type="number"
                        className="max-w-52"
                        id="redeemable_for.amount"
                        label="Total Number of Events"
                        min={0}
                        value={
                            typeof value?.amount === 'undefined'
                                ? '0'
                                : value?.amount
                        }
                        onChange={newValue =>
                            onChange({ ...value, amount: newValue || 0 })
                        }
                    />
                )}
            </div>

            {value?.type !== 'specific' && value?.type !== 'nothing' && (
                <>
                    <div className="input-label mt-4">
                        Any of these Event Types
                    </div>
                    <CompactEventTypeSelect
                        id="redeemable_for.eventTypes"
                        className="border rounded-lg"
                        initialOpen={isNew}
                        showEmptyError={true}
                        value={value?.eventTypes || []}
                        onChange={newValue =>
                            onChange({ ...value, eventTypes: newValue })
                        }
                    />
                </>
            )}

            {value?.type === 'nothing' && (
                <InfoMessageBlock showIcon={true} className="mt-2">
                    This cannot be redeemed for any appointments. This is
                    typically used for payment plans or to provide a
                    subscription that discounts only.
                </InfoMessageBlock>
            )}

            {value?.type === 'specific' && (
                <>
                    <div className="input-label mt-4">
                        Amount Redeemable of Each Event Type
                    </div>
                    <SpecificEventTypeInput
                        value={value?.specific || {}}
                        onChange={newValue =>
                            onChange({ ...value, specific: newValue })
                        }
                    />
                </>
            )}
        </div>
    );
};

export default RedeemableForInput;
